import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { CwActionIcon, CwIcon, CwTooltip } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { iconsMap } from '~/app/constants/notificationIconsMap';
import { DateFormat } from '~/app/enums/DateFormat';
import { TherapyJobNotification } from '~/app/models/TherapyJobNotification';
import { LocalizedDatePipe } from '~/app/pipes/LocalizedDate';
import { PersonNamePipe } from '~/app/pipes/PersonName';
import { SafeHtmlPipe } from '~/app/pipes/SafeHtml';

@Component({
  selector: 'gplus-alarm-card',
  imports: [
    CwIcon,
    CommonModule,
    TranslateModule,
    PersonNamePipe,
    LocalizedDatePipe,
    CwTooltip,
    SafeHtmlPipe,
    CwActionIcon
  ],
  templateUrl: './alarm-card.component.html',
  styleUrl: './alarm-card.component.scss',
  host: {
    '[class]': 'notification()?.level'
  }
})
export class AlarmCardComponent {
  public notification = input<TherapyJobNotification>();
  public hide = output<void>();

  public iconsMap: { [key: string]: string } = iconsMap;
  public dateFormat = DateFormat;
}
